import React from 'react';
import Image from 'next/image';
import styles from './MeetPlatformSelector.module.scss';
import GoogleMeetIcon from '@/app/assets/images/icons/googleMeet.svg';
import TeamsIcon from '@/app/assets/images/icons/teams.svg';
import tick from '@/app/assets/images/icons/tick.svg';
import {useTranslation} from "react-i18next";

const MeetPlatformSelector = ({value, onChange}) => {
    const {t} = useTranslation();

    const isTeams = value === 'teams';
    const isGoogle = value === 'google'
    return (<>
            <p className={styles.label}>{t('meetPlatformSelection.choose')}</p>
            <div className={styles.wrapper}>
                <div
                    className={`${styles.card} ${isTeams ? styles.active : ''}`}
                    onClick={() => onChange('teams')}
                >
                    {isTeams && <div className={styles.tick}><Image src={tick} alt={'tick'}/></div>}
                    <Image src={TeamsIcon} alt="Teams icon"/>
                    <h4>Teams</h4>
                </div>

                <div
                    className={`${styles.card} ${isGoogle ? styles.active : ''}`}
                    onClick={() => onChange('google')}
                >
                    {isGoogle && <div className={styles.tick}><Image src={tick} alt={'tick'}/></div>}
                    <Image src={GoogleMeetIcon} alt="Google meet icon"/>

                    <h4>Google meet</h4>
                </div>
            </div>
        </>);
};

export default MeetPlatformSelector;
